import MaintenancePage from "@/features/system-settings/pages/Maintenance";

const Maintenance = () => {
  return <MaintenancePage />;
};

export default Maintenance;
